import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ClipLoader as Loader } from 'halogenium';

import icons from '../../assets/icons';


import './Trader.css';


class Trader extends Component {
  static get propTypes() {
    return {
      trader: PropTypes.object,
      onSetActive: PropTypes.func.isRequired,
      onRemoveTrader: PropTypes.func.isRequired
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      active: !!props.trader.Active,
      deleting: false
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      active: !!props.trader.Active
    });
  }

  renderActiveCheck() {
    const { trader } = this.props;
    const { active } = this.state;

    const checkId = `checkbox-${trader.Id}-active`;
    const checkImg = active ? icons.blue.checkbox_on : icons.blue.checkbox_off;

    return (<div className="AdminTraders-active">
      <input
        type="checkbox"
        checked={active}
        onChange={event => this.setActive(event.target.checked)}
        id={checkId}
      /><label htmlFor={checkId}>
        <img className="checkImg" src={checkImg} alt="checkbox" />
      </label>
    </div>);
  }

  renderDelete() {
    const { trader } = this.props;
    return (trader.CanDelete
      ? this.renderDeleteButton()
      : null);
  }

  renderDeleteButton() {
    const { deleting } = this.state;
    return (deleting
      ? <Loader className="AdminTraders-deletingloader" loading color="#26A65B" size="8px" margin="0px" />
      : <button
        type="button"
        className="AdminTraders-removetrader"
        onClick={() => this.removeTrader()}
      />);
  }

  setActive(isActive) {
    const { onSetActive } = this.props;

    this.setState({
      active: isActive
    });

    onSetActive(isActive);
  }

  setDeleting(deleting) {
    this.setState({ deleting });
  }

  removeTrader() {
    const { onRemoveTrader, trader } = this.props;
    this.setDeleting(true);
    if (window.confirm(`Are you sure you want to delete ${trader.Name}`)) {
      onRemoveTrader().catch(() => this.setDeleting(false));
    } else {
      this.setDeleting(false);
    }
  }

  render() {
    const { trader } = this.props;

    return (
      <tr className="AdminTraders-row" key={trader.Id}>
        <td className="name">{trader.Name}</td>
        <td className="active">{this.renderActiveCheck()}</td>
        <td className="delete">{this.renderDelete()}</td>
      </tr>
    );
  }
}

export default Trader;



// WEBPACK FOOTER //
// ./src/admin/traders/Trader.js